<div *ngFor="let error of errors">
  <div [id]="getErrorId(error.name)"
       [innerHTML]="error.text">
  </div>
</div>
